import React from "react";
import { Link } from "react-router-dom";
import andUsLogo from "../../images/logo.png";

export default function AccessRouteState({ title = "Checking your access…", message, action }) {
  return (
    <main className="pa-route-state" aria-live="polite">
      <Link className="pa-route-state__logo" to="/" aria-label="AndUs home">
        <img src={andUsLogo} alt="AndUs" />
      </Link>
      <span className="pa-route-state__spinner" aria-hidden="true" />
      <h1>{title}</h1>
      {message ? <p>{message}</p> : null}
      {action}
    </main>
  );
}
